<p>logout works!</p>
